<p>logout works!</p>
